import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosConfig";
import {
  Navbar,
  Container,
  Nav,
  Badge,
  Button,
  Row,
  Col,
  Card,
  Spinner,
} from "react-bootstrap";

const RelationshipManagersList = () => {
  const navigate = useNavigate();
  const [relationshipManagers, setRelationshipManagers] = useState([]);
  const [loading, setLoading] = useState(true);

  // User info (mocked or fetched from auth context)
  const username = "Admin User";
  const role = "Admin";

  useEffect(() => {
    const fetchRelationshipManagers = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        const response = await api.get("/api/admin/users/all", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const allUsers = response.data || [];
        const relationshipManagers = allUsers.filter(
          (user) => user.role === "relationship_manager"
        );
        setRelationshipManagers(relationshipManagers);
      } catch (error) {
        console.error("Error fetching relationship managers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRelationshipManagers();
  }, []);

  // Logout handler (mock)
  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminRole");
    localStorage.removeItem("adminName");
    navigate("/admin-login");
  };

  return (
    <>
      <Navbar bg="light" expand="lg" className="shadow-sm">
        <Container>
          <Navbar.Brand>20 Points Sales Tracker</Navbar.Brand>
          <Nav className="ms-auto align-items-center">
            <span className="me-3">{username}</span>
            <Badge bg="primary" className="me-3">
              {role}
            </Badge>
            <Button variant="outline-danger" size="sm" onClick={handleLogout}>
              Logout
            </Button>
          </Nav>
        </Container>
      </Navbar>

      <Container fluid className="mt-3">
        <Row>
          <Col>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3>Relationship Managers List</h3>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => navigate("/admin-dashboard")}
              >
                Back to Dashboard
              </Button>
            </div>
            {loading ? (
              <div className="text-center my-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Location</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {relationshipManagers.map((relationshipManager) => (
                      <tr key={relationshipManager.id}>
                        <td>{relationshipManager.id}</td>
                        <td>{relationshipManager.name}</td>
                        <td>{relationshipManager.email || "N/A"}</td>
                        <td>{relationshipManager.location || "N/A"}</td>
                        <td>
                          {relationshipManager.is_verified ? (
                            <Badge bg="success">Verified</Badge>
                          ) : (
                            <Badge bg="warning">Pending Verification</Badge>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {relationshipManagers.length === 0 && (
                  <p className="text-center">No relationship managers found.</p>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RelationshipManagersList;
